import { NavLink, Outlet } from 'react-router-dom';
import { cx } from '@mobi/web';

const TABS = [
  {
    to: '/',
    label: 'Corrida',
    icon: (
      <path d="M5 16.5V18a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-6l2-5.2A2 2 0 0 1 5.9 5.5h12.2a2 2 0 0 1 1.9 1.3L22 12v6a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1.5H5Zm.6-9L4.4 11h15.2l-1.2-3.5H5.6ZM6.5 15a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm11 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z" />
    ),
  },
  {
    to: '/carteira',
    label: 'Carteira',
    icon: (
      <path d="M3 7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2h1a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7Zm2 2v8h15V9H5Zm12 3.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Z" />
    ),
  },
  {
    to: '/historico',
    label: 'Viagens',
    icon: (
      <path d="M13 3a9 9 0 1 0 8.5 12h-2.2A6.8 6.8 0 1 1 13 5.2V9l5-4.5L13 0v3Zm-1 5v5.4l4.2 2.5.8-1.3-3.5-2.1V8H12Z" />
    ),
  },
  {
    to: '/perfil',
    label: 'Perfil',
    icon: (
      <path d="M12 2a5 5 0 1 1 0 10 5 5 0 0 1 0-10Zm0 12c5 0 9 2.5 9 6v2H3v-2c0-3.5 4-6 9-6Z" />
    ),
  },
];

export function Shell() {
  return (
    <div className="h-app flex flex-col bg-surface">
      <main className="min-h-0 flex-1">
        <Outlet />
      </main>

      <nav className="border-t border-line bg-surface pb-[max(0.5rem,env(safe-area-inset-bottom))]">
        <ul className="mx-auto flex max-w-md">
          {TABS.map((tab) => (
            <li key={tab.to} className="flex-1">
              <NavLink
                to={tab.to}
                end={tab.to === '/'}
                className={({ isActive }) =>
                  cx(
                    'flex min-h-14 flex-col items-center justify-center gap-1 pt-2 text-xs font-medium transition',
                    isActive ? 'text-brand' : 'text-faint',
                  )
                }
              >
                {({ isActive }) => (
                  <>
                    <svg
                      viewBox="0 0 24 24"
                      className={cx('h-6 w-6', isActive ? 'fill-brand' : 'fill-faint')}
                      aria-hidden="true"
                    >
                      {tab.icon}
                    </svg>
                    {tab.label}
                  </>
                )}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
    </div>
  );
}
